import axios from 'axios';

const sdk = axios.create({
  baseURL: import.meta.env.VUE_APP_FUNC_URL,
  timeout: 50000,
});

export const randomImages = params => sdk.get('/random-images', { params });
